<script setup>
  import { ref, watch, onMounted, watchEffect} from 'vue';
  import { useUserStore } from '@/stores/UserStore'
  import BaseModal from './base/BaseModal.vue';
  
  const showModal = defineModel('showModal', { default: false });
  const emits = defineEmits(['close']);
  const props = defineProps({
    profileId: {
      type: Number,
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();

  const profileName = ref(``);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function handleDeleteProfile() {
    if (userStore.currentProfileId === props.profileId) {
      userStore.setDefaultProfile(userStore.userProfiles.profiles[0].profile_id);
    }

    await userStore.deleteProfile(props.profileId);
    await userStore.getProfiles(true);

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: `Deleted profile: ${profileName.value}.`
      })
    }

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });

  watch(() => props.profileId, () => {
    profileName.value = userStore.getProfileById(props.profileId).name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Delete Profile?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <p class="jwx-modal__text">Are you sure you want to delete profile:<br><strong>{{ profileName }}</strong>?</p>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Cancel
      </button>
        <button 
          type="button" 
          @click.prevent="handleDeleteProfile"
          class="jwx-button jwx-button--danger"
        >
          Delete
        </button>
      </div>
    </div>
  </BaseModal>
</template>